// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.save-home .welcome-banner {
  min-height: 225px;

  padding-top: 45px;

  background: linear-gradient(126deg, #1a4480 53%, rgb(0 0 0 / 0%) 53%),
    linear-gradient(126deg, #173e73 75%, #143667 75%);
}

.save-home .welcome-banner a,
.save-home .welcome-banner a:visited {
  color: #005ea2;
  text-decoration: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/welcome-banner/welcome-banner.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;;EAEjB,iBAAiB;;EAEjB;qDACmD;AACrD;;AAEA;;EAEE,cAAc;EACd,qBAAqB;AACvB","sourcesContent":[".save-home .welcome-banner {\n  min-height: 225px;\n\n  padding-top: 45px;\n\n  background: linear-gradient(126deg, #1a4480 53%, rgb(0 0 0 / 0%) 53%),\n    linear-gradient(126deg, #173e73 75%, #143667 75%);\n}\n\n.save-home .welcome-banner a,\n.save-home .welcome-banner a:visited {\n  color: #005ea2;\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
